module.exports = __webpack_public_path__ + "static/img/color.f54a97c1.png";